import React, { useEffect, useState } from "react";
import BreadcrumbsHeader from "../breadcrumbs/BreadcrumbsHeader";
import { FaArrowRight, FaArrowLeft, FaLongArrowAltRight, FaPlay } from "react-icons/fa";
import Brands1 from "../brands/Brands1";
import Slider from "react-slick";
import AOS from "aos";
import "aos/dist/aos.css";

const faqs = [
  {
    question: "What's Online Reputation Management (ORM)?",
    answer:
      "ORM is like looking after your online image. It's making sure that when people search for you online, they find positive facts that make you look awesome.",
  },
  {
    question: "Why should I bother with ORM for my business?",
    answer:
      "Your online reputation matters. Some people blindly trust what they find online, and a good reputation can bring in more customers.",
  },
  {
    question: "How does ORM actually work?",
    answer:
      "You keep an eye on online reviews, comments, and news about your business. If there's something negative, you address it to make things right with a positive approach.",
  },
  {
    question: "Where can I find these reviews and comments?",
    answer:
      "They can be on review sites, social media, forums, or news articles. Basically, wherever people are talking about your business, ORM helps in appealing to customers.",
  },
  {
    question: "How does ORM help my business shine?",
    answer:
      "Positive online vibes build trust between your Business and customers. Potential customers who see good things about you are more likely to choose your products or services.",
  },
  {
    question: "Can I fix a bad online reputation?",
    answer:
      "Yes, you can! By responding politely to negative feedback and effectively working to resolve issues, you can turn things around and show that you care about your customers.",
  },
];

const testimonials = [
  {
    name: "Arpan Ghosh",
    text: "The job which I appointed them was nicely done. The only thing I was concerned about was if they were authentic or not. But everything turned out good and these guys are 100% authentic. Highly recommended by me. I would love to work with these guys in the near future.",
    img: "/images/male-user.png",
  },
  {
    name: "Zeus",
    text: "I took the e-mail marketing service from them. They were highly dedicated towards their work and always kept me updated. After the splendid service they gave me for e-Mail marketing, I asked them for the Search Engine Optimization service as well. It also turned out well and I can actually see a change in my website. The reach of my website seems to be increased and I can also see new audiences checking my website. 5 stars to their work. 😉",
    img: "/images/male-user.png",
  },
  {
    name: "Mr. Badshah",
    text: "I appointed this company for e-mail marketing. To be honest, they did a splendid job. They completely nailed it. I can see the difference in my e-commerce business. If you are looking for a company for the e-mail marketing service, you can choose Digital India Leader blindfolded. 5 stars for there service.",
    img: "/images/male-user.png",
  },
  {
    name: "Sonia Sharma",
    text: "Best in class service. I hired them for a Search Engine Optimization service, they did a splendid job. I can legit see the positive response on my website and can see the reach has been increased in a drastic manner. Cheers to DIL team.",
    img: "/images/female-user.png",
  },
  {
    name: "Jason D. Sealey",
    text: "I hired them for PPC marketing. They provided me with good service. I am happy personalised attitude of dealing. Thanks to these people, my returns has increased and I can finally see a positive response on my website.",
    img: "/images/male-user.png",
  },
];


const ORM = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [openFAQ, setOpenFAQ] = useState(0);
  const NextArrow = ({ onClick }) => (
    <div className="custom-arrow next-arrow" onClick={onClick}>
      <FaArrowRight />
    </div>
  );
  
  const PrevArrow = ({ onClick }) => (
    <div className="custom-arrow prev-arrow" onClick={onClick}>
      <FaArrowLeft />
    </div>
  );

  return (
    <>
      <BreadcrumbsHeader
        title="Online Reputation Management"
        backgroundImage="/images/breadcrumbs/digital-marketing-cover.jpg"
      />

      {/* ================== Enquiry Section ================== */}
      <section className="section-home-secondary" id="enquire_now">
        <div className="b-home-about relative">
          <div className="vertical-container-top-mod vertical-left home-about-side-title hidden-md">
            <span className="vertical-text-main color-add text-uppercase">
              ISOLS Group
            </span>
            <span className="vertical-text-additional color-add-2 text-uppercase">
              DM
            </span>
          </div>

          <div className="container">
            <div className="row">
              {/* ========== LEFT CONTENT ========== */}
              <div className="col-xs-12 col-sm-6">
                <div
                  className="b-mod-heading1 wow fadeInDown"
                  data-aos="fadeInDown"
                >
                  <p className="first-heading font-secondary" style={{ fontSize: 20, marginBottom: 10 }}>
                    Online Reputation Management Services
                  </p>
                  <h2 className="heading-line line-right1 customColor customPseudoElBg">
                    <strong>Best ORM Services</strong>
                  </h2>
                  <p className="orm">
                    GOOD REPUTATION GIVES SUSTAINABILITY TO GO A LONG WAY!
                  </p>
                </div>

                <div className="b-text">
                  <p>
                    Reputation is the key objective of everything, starting from
                    individuals to companies and a bad reputation can lead to severe
                    destructions. A wrong or negative review has the power of driving
                    away your potential crowd. What you need is, ISOLS Group's ORM
                    Experts Management! <br />
                    Being a top-tier online reputation management company we know how
                    much a good word is important to be in business and to handle the
                    bogus & fake reviews which are done by unethical means. With our
                    online reputation monitoring, our clients’ positive image is our
                    topmost priority. Our team of professionals ensures to manage your
                    brand's online credibility profoundly and with due diligence.
                  </p>
                </div>
              </div>

              {/* ========== RIGHT FORM ========== */}
              <div className="col-xs-12 col-sm-6" data-aos="fade-left">
                <div className="footer-form" id="contact-form">
                 
                  {/* Flowlu Script */}
                  <script
                    type="text/javascript"
                    dangerouslySetInnerHTML={{
                      __html: `(function (w, d, c) { 
                        (w[c] = w[c] || []).push(function(flowluHost) { 
                          try { 
                            new FlowluForm.init({ 
                              id: 101591, 
                              token: 'a1b962d0c1fb87354b47c32c88929ea2', 
                              host: flowluHost 
                            }); 
                          } catch(e){} 
                        }); 
                        var n = d.getElementsByTagName("script")[0], 
                            s = d.createElement("script"), 
                            f = function () { n.parentNode.insertBefore(s, n); }; 
                        s.type = "text/javascript"; 
                        s.async = true; 
                        s.src = "https://erp.isolsgroup.com/application/classes/Module/Crm/static/js/ext-form.js"; 
                        if (w.opera == "[object Opera]") { 
                          d.addEventListener("DOMContentLoaded", f, false); 
                        } else { f(); } 
                      })(window, document, "flowlu_forms");`,
                    }}
                  />

                  <form
                    action="/online-reputation-management"
                    method="post"
                    className="form-message-1 text-left"
                  >
                    <div className="flowlu-form">
                       <h2
                    className="footer-form-title"
                    style={{ color: "#000", fontSize: "20px" }}
                  >
                    SEEK EXPERT'S ADVICE & GET PROPOSAL
                  </h2>

                      <input
                        type="text"
                        required
                        placeholder="Your Name*"
                        name="contact_name"
                        className="flowlu-input"
                      />
                      <input
                        type="text"
                        required
                        placeholder="Your Company Name*"
                        name="contact_company"
                        className="flowlu-input"
                      />
                      <input
                        type="email"
                        required
                        placeholder="Email Address*"
                        name="contact_email"
                        className="flowlu-input"
                      />
                      <input
                        type="number"
                        required
                        placeholder="Mobile Number*"
                        name="contact_phone"
                        className="flowlu-input"
                      />
                      <textarea
                        rows="5"
                        placeholder="Type Your Query"
                        required
                        name="description"
                        className="flowlu-input"
                        style={{ width: "100%", height: "146px" }}
                      ></textarea>

                      <div className="flowlu-row-submit">
                        <button
                          type="submit"
                          className="flowlu-submit btn-default-arrow"
                        >
                          <FaLongArrowAltRight /> Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================== Best ORM Company ================== */}
      <section className="section-services">
        <div className="container text-center">
          <h2
            style={{
              fontSize: "40px",
              color: "#ff9600",
              lineHeight: "1.2",
              fontFamily: "Raleway",
              fontWeight: 700,
            }}
          >
            Best Online Reputation Management Company
          </h2>
          <p className="orm">
            We claim to be the best in the market with our effective and unique ORM
            services. No matter how much damage you and your brand have undergone, we at
            ISOLS Group with a team of certified professionals are here for you. We
            would love to take you into a beautiful journey of earning a positive
            reputation. We stand strongly and face all the challenges to achieve the
            desired outcome. Our reputation management services are exclusively made for
            you depending on your situation. With us all you need to do is sit back and
            watch your and your brand's image reach heights!
          </p>
          <p>
            IT IS NEVER TOO LATE! <br />
            ISOLS Group with its most unique ORM services makes sure to provide you and
            your brand its much-deserved reputation.
          </p>
        </div>
      </section>

      <section className="section-overview">
        <div className="container">
          <h2
            style={{
              fontSize: "48px",
              color: "#ff9600",
              textAlign: "center",
              fontFamily: "Raleway",
              fontWeight: 700,
              padding: "10px 0 22px",
            }}
          >
            ORM Overview
          </h2>

          <div className="b-services-holder1">
            {/* ---- Row 1 ---- */}
            <div className="row">
              <div className="col-md-4 col-sm-6">
                <div className="b-services-item wow fadeInUp">
                  <div className="services-icon">
                    <img
                      src="/images/solution-services-icons/orm.png"
                      alt="STRATEGY DEVELOPMENT"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor font-secondary text-uppercase">
                      STRATEGY DEVELOPMENT
                    </h6>
                    <p>
                      At ISOLS Group, we start by understanding your business and current situation and accordingly we strategize for your betterment.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-sm-6">
                <div className="b-services-item wow fadeInUp">
                  <div className="services-icon">
                    <img
                      src="/images/reputation-01.png"
                      alt="PROTECTING ONLINE REPUTATION"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor font-secondary text-uppercase">
                      PROTECTING ONLINE REPUTATION
                    </h6>
                    <p>
                     We, at ISOLS Group believe that a good reputation goes a long way. And our team of ORM experts makes sure to protect your brand's online image and keep it up to date.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-sm-6">
                <div className="b-services-item wow fadeInUp">
                  <div className="services-icon">
                    <img
                      src="/images/fake-website.png"
                      alt="RESTRICTING FAKE WEBSITES"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor font-secondary text-uppercase">
                      RESTRICTING FAKE WEBSITES
                    </h6>
                    <p>
                      With our Online Reputation Monitoring we make sure to suppress fake accounts visit and actions in your website.
                    </p>
                  </div>
                </div>
              </div>

              
            </div>
            {/* ---- End Row 1 ---- */}

            {/* ---- Row 2 ---- */}
            <div className="row">
              <div className="col-md-4 col-sm-6">
                <div className="b-services-item wow fadeInUp">
                  <div className="services-icon">
                    <img
                      src="/images/internet-raputation.png"
                      alt="FIXING INTERNET REPUTATION"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor font-secondary text-uppercase">
                      FIXING INTERNET REPUTATION
                    </h6>
                    <p>
                     Our tech-savvy experts exclusively work for you and your brand's reputation to achieve maximum positive outcome.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6">
                <div className="b-services-item wow fadeInUp">
                  <div className="services-icon">
                    <img
                      src="/images/ratings.png"
                      alt="IMPROVE RATINGS & REVIEWS"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor font-secondary text-uppercase">
                      IMPROVE RATINGS & REVIEWS
                    </h6>
                    <p>
                      A bad review or rating might hamper your reputation. We, at ISOLS Group identify those negative views and work on it efficiently.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-sm-6">
                <div className="b-services-item wow fadeInUp">
                  <div className="services-icon">
                    <img
                      src="/images/brand-search-con.png"
                      alt="INCREASE BRAND SEARCH"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor font-secondary text-uppercase">
                      INCREASE BRAND SEARCH
                    </h6>
                    <p>
                   Our ORM services focus on strategies which focus on managing your brand search amongst all the major search engine result pages.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-sm-6">
                <div className="b-services-item wow fadeInUp">
                  <div className="services-icon">
                    <img
                      src="/images/business-raputaion-icon.png"
                      alt="MANAGING BUSINESS REPUTATION"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor font-secondary text-uppercase">
                      MANAGING BUSINESS REPUTATION
                    </h6>
                    <p>
                     No matter where your business stands now, our professionals with their marketing expertise will boost your business image online.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-sm-6">
                <div className="b-services-item wow fadeInUp">
                  <div className="services-icon">
                    <img
                      src="/images/google.png"
                      alt="FIXING GOOGLE RESULTS"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor font-secondary text-uppercase">
                      FIXING GOOGLE RESULTS
                    </h6>
                    <p>
                     Your company's image in Google search results might not be up to the mark. Our Google ORM services make sure that your reputation is optimised.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6">
                <div className="b-services-item wow fadeInUp">
                  <div className="services-icon">
                    <img
                      src="/images/online-raputatio02.png"
                      alt="FAST & EFFICIENT REPUTATION MANAGEMENT SERVICES"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor font-secondary text-uppercase">
                      FAST & EFFICIENT REPUTATION MANAGEMENT SERVICES
                    </h6>
                    <p>
                     ISOLS Group is a trustworthy Reputation management company with its fast and effective ORM services.
                     </p>
                  </div>
                </div>
              </div>
            </div>
            {/* ---- End Row 2 ---- */}
          </div>
        </div>
      </section>

          <div className="b-home-services">
      <div className="container">
        <h2
          className="vc_custom_heading vc_custom_1490112359046"
          style={{
            fontSize: "40px",
            color: "#ff9600",
            lineHeight: 1.2,
            textAlign: "center",
            fontFamily: "Raleway",
            fontWeight: 700,
            fontStyle: "normal",
            padding: "10px 0 22px",
          }}
        >
          Best ORM Services in India
        </h2>

        <div className="b-services-holder clearfix">
          <div className="row">
          <div
            className="col-xs-12 col-sm-6"
            style={{ background: "#fff" }}
          >
            <div
              className="b-services-item wow fadeInLeft"
              style={{ visibility: "visible", animationName: "fadeInLeft" }}
            >
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  We would love to hear from you and be a part of your journey!
                </h6>
                <p>
                  Sometimes a false accusation or unintentional mistake can
                  pollute your reputation which in turn can harm your or your
                  brand's career. Here comes ISOLS Group, the best business and
                  personal Reputation Management Company in India. Here we
                  provide personal, brand and Google ORM services from the best
                  ORM experts. We have very efficient damage control measures
                  which mends your or your brand's negative portrayal into a
                  positive one.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-xs-12 col-sm-6"
            style={{ background: "#fff" }}
          >
            <div className="b-services-item" style={{ background: "#fff" }}>
              <div className="services-text">
                <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                  What makes us the best online reputation management company
                  in the market!
                </h6>
                <p>
                  We make sure you and your brand's names steer clear of
                  controversies. We aim at providing the best quality ORM
                  services within your budget.
                  <br />
                  From small scale start-ups to the giant conglomerates we make
                  sure your brand's name is worthy of all the praises. Our
                  certified professionals have customised and exclusive ORM
                  strategies for every situation.
                </p>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>

      {/* ================== WHY CHOOSE ISOLS ================== */}
      <section className="b-home-services">
        <div className="container">
          <h2 className="container text-center"
            style={{
              fontSize: "40px",
              color: "#ff9600",
              fontFamily: "Raleway",
              fontWeight: 700,
              padding: "10px 0 22px",
            }}
          >
            Why Choose the ISOLS Group?
          </h2>

          <div className="b-services-holder clearfix" style={{ paddingBottom: 30 }}>
            {/* ---- Row 1 ---- */}
            <div className="row">
              <div className="col-xs-12 col-sm-3">
                <div className="b-services-item wow fadeInUp">
                  <div className="services-text">
                    <h6 className="services-title customColor font-secondary text-uppercase">
                      CUSTOMISED SOLUTIONS
                    </h6>
                    <p>
                      We analyse your brand’s situation and reputation, then strategize custom ORM services accordingly.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-3">
                <div className="b-services-item wow fadeInUp">
                  <div className="services-text">
                    <h6 className="services-title customColor font-secondary text-uppercase">
                      POCKET-FRIENDLY PRICES
                    </h6>
                    <p>
                      Our ORM services are efficient, transparent, and affordable for every business size.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-3">
                <div className="b-services-item wow fadeInUp">
                  <div className="services-text">
                    <h6 className="services-title customColor font-secondary text-uppercase">
                      FLEXIBILITY
                    </h6>
                    <p>
                      We go the extra mile to achieve the desired outcome. With us, your brand is in safe hands.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-3">
                <div className="b-services-item wow fadeInUp">
                  <div className="services-text">
                    <h6 className="services-title customColor font-secondary text-uppercase">
                      BUSINESS-DRIVEN RESULTS
                    </h6>
                    <p>
                      Our ORM experts with proven strategies ensure your brand image reaches new heights.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* ---- End Row 1 ---- */}
          </div>
        </div>
      </section>


      {/* ================== Video Section ================== */}
      <section className="section-about1">
        <div className="container">
          <div className="b-home-video-block text-center">
            <div className="b-video-holder" data-aos="fade-left">
              <a
                href="#"
                className="video-image playVideo1"
                data-toggle="modal"
                data-target="#myModal"
              >
                <FaPlay className="demo-icon play-icon" /><br></br>
                <span className="video-title">Play the Video</span>
              </a>
            </div>
          </div>
        </div>
      </section>


      <section>
    <div className="container" style={{ padding: "60px 0" }}>
  <div className="row">

    {/* LEFT SIDE – FAQ */}
    <div className="col-lg-6 col-md-12">
      <section className="faq-section">
        <h2 className="faq-title">ASK YOUR QUERIES?</h2>
        <p className="faq-subtitle">SEO FAQs</p>

        <div className="faq-box">
          {faqs.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${openFAQ === index ? "active" : ""}`}
              onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
            >
              <div className="faq-question">
                <span className="faq-icon">
                  {openFAQ === index ? "✖" : "➕"}
                </span>
                {item.question}
              </div>

              {openFAQ === index && (
                <div className="faq-answer">{item.answer}</div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>

    {/* RIGHT SIDE – TESTIMONIALS */}
    <div className="col-lg-6 col-md-12">
      <section className="testimonial-section">
  <h2 className="testimonial-title">What our clients say about us</h2>

  <Slider
    dots={true}
    infinite={true}
    speed={500}
    slidesToShow={1}
    slidesToScroll={1}
    autoplay={true}
    autoplaySpeed={3000}
    arrows={true}
    nextArrow={<NextArrow />}
    prevArrow={<PrevArrow />}
  >
    {testimonials.map((item, i) => (
      <div key={i} className="testimonial-card">
        <img src={item.img} alt="" className="testimonial-img" />
        <h4 className="testimonial-name">{item.name}</h4>
        <p className="testimonial-text">{item.text}</p>
      </div>
    ))}
  </Slider>
</section>

    </div>

  </div>
</div>

    </section>

      <section
            className="section-about1 sectionn"
            style={{ paddingBottom: "100px" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12">
                  <h2
                    style={{
                      fontSize: "25px",
                      color: "#ff9600",
                      lineHeight: 1.2,
                      textAlign: "center",
                      fontFamily: "Raleway",
                      fontWeight: 700,
                      fontStyle: "normal",
                      padding: "0 0 30px 0",
                      textTransform: "uppercase",
                    }}
                    className="vc_custom_heading vc_custom_1490112359046"
                  >
                    What Our Client Feel About Us
                  </h2>
      
                  <div className="row">
                    <div className="col-lg-4">
                      <iframe
                        width="100%"
                        height="310"
                        src="https://www.youtube.com/embed/ofWi6TePZQo"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Client Feedback 1"
                      ></iframe>
                    </div>
      
                    <div className="col-lg-4">
                      <iframe
                        width="100%"
                        height="310"
                        src="https://www.youtube.com/embed/3iJH9el9dzQ"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Client Feedback 2"
                      ></iframe>
                    </div>
      
                    <div className="col-lg-4">
                      <iframe
                        width="100%"
                        height="310"
                        src="https://www.youtube.com/embed/Hfh01auRGAw"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Client Feedback 3"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
     {/* Brands Section */}
      <Brands1 />
      <div className="b-plans-holder section-about1">
            <div className="container">
              <center>
                <div className="p-sz" style={{ marginTop: "20px" }}>
                  <p style={{ fontSize: "17px" }}>
                    <a
                      href="https://www.digitalindialeader.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLongArrowAltRight style={{ marginRight: "5px" }} />
                      Know more
                    </a>{" "}
                    about various digital marketing solutions & services offered by
                    Digital India Leader - A digital marketing wing of ISOLS Group
                  </p>
                </div>
              </center>
            </div>
          </div>
    </>
  );
};

export default ORM;
